export default __webpack_public_path__ + "static/fix_roof-548c5275ba0d8448e655afe45759b709.jpg";